// eslint-disable-next-line no-shadow
export enum GoalGroupChartType {
  goalProgress = 'GOAL_PROGRESS',
  taskCompletion = 'TASK_COMPLETION',
}
